import React, { useEffect, useState } from 'react';

type Props = {
    minHeight?: string;
    delay?: number;
};

export const Delay: React.FC<React.PropsWithChildren<Props>> = React.memo(({ delay, minHeight = '80vh', children }) => {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const int = setTimeout(() => setReady(true), delay);
        return () => {
            clearTimeout(int);
        };
    }, [delay]);
    if (!ready) return <div style={{ minHeight }} />;
    return children as any;
});
